import { c as _c } from "react/compiler-runtime";
import { MaintenanceBanner } from './maintenance-banner';
import { RestrictionBanner } from './restriction-banner';
export const Banner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><RestrictionBanner /><MaintenanceBanner /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};